import React from 'react';
import styled from 'styled-components';
import { Section, Container, BlockTitle, BlockSubtitle, BlockHeader, t } from '../styles/shared';

const Grid = styled.div`
  display: grid;
  grid-template-columns: ${({ $cols }) => `repeat(${$cols}, 1fr)`};
  gap: 24px;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const Card = styled.div`
  padding: 32px 24px; text-align: center;
  ${({ $style }) => $style === 'bordered' && `border: 1px solid ${t.border}; border-radius: 8px;`}
  ${({ $style }) => $style === 'filled' && `background: ${t.bgAlt}; border-radius: 8px;`}
`;

const IconWrap = styled.div`
  display: inline-flex; align-items: center; justify-content: center;
  width: 64px; height: 64px; margin-bottom: 16px;
  background: ${t.primary}; border-radius: 50%; color: #fff;
  svg { width: 28px; height: 28px; }
`;

const CardTitle = styled.h3`
  margin: 0 0 8px 0; font-family: ${t.fontHeading};
  font-size: 1.25rem; font-weight: 600; color: ${t.text};
`;

const CardDesc = styled.p`
  margin: 0; color: ${t.textLight}; line-height: 1.6;
`;

const ICONS = {
  leaf: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>,
  truck: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
  heart: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>,
  shield: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  star: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  check: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>,
  award: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg>,
};

const FeatureCardsBlock = ({ content = {}, settings = {} }) => {
  const { title = '', subtitle = '', cards = [], columns = 3, cardStyle = 'bordered' } = content;
  const { backgroundColor = '', padding = 'large' } = settings;
  const cols = Math.min(columns, Math.max(cards.length, 1));

  return (
    <Section $padding={padding} $bgColor={backgroundColor}>
      <Container>
        {(title || subtitle) && (
          <BlockHeader $center>
            {title && <BlockTitle style={{ textAlign: 'center' }}>{title}</BlockTitle>}
            {subtitle && <BlockSubtitle style={{ textAlign: 'center' }}>{subtitle}</BlockSubtitle>}
          </BlockHeader>
        )}
        <Grid $cols={cols}>
          {cards.map((card, i) => (
            <Card key={i} $style={cardStyle}>
              {card.icon && <IconWrap>{ICONS[card.icon] || <span style={{ fontSize: '1.5rem' }}>{card.icon}</span>}</IconWrap>}
              {card.title && <CardTitle>{card.title}</CardTitle>}
              {card.description && <CardDesc>{card.description}</CardDesc>}
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default FeatureCardsBlock;
